
  <div class="row">
    <h5 class="card-title d-flex align-items-center"  >
      <img alt="Aggiungi" height="40" width="50" src="assets/images/icon/Colli@4x.png"/>
      &nbsp;
      COLLI
      &nbsp;
      <span class="badge num">{{myProp.length}}</span>
    </h5>
    <div *ngIf="!isModifyDisabled" class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
      <button class="btn" style="width: 100%;" (click)="add()"
        type="button"><img alt="Aggiungi" height="30" width="34" src="assets/images/icon/AddCollo@4x.png"/> </button>
    </div>
  </div>

<div class="table-responsive">
    <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
    <thead>
      <tr>
        <th>Peso (Kg)</th>
        <th scope="col">Altezza (cm)</th>
        <th scope="col">Larghezza (cm)</th>
        <th scope="col">Profondità (cm)</th>
        <th scope="col">Peso volumetrico (Kg/m3)</th>
        <th scope="col">Peso volumetrico 3333 (Kg/m3)</th>
        <th scope="col">Peso tassabile (Kg)</th>
        <th scope="col" *ngIf="!isModifyDisabled">Azioni</th>
      </tr>
    </thead>
    <tbody class="nowrap">
      <tr *ngFor="let item of myProp">
        <td class="align-middle">
          <div *ngIf="!item.modifica">
            <i-feather name="box" class="feather-sm"></i-feather>
            <span class="span_text">
              {{ item.kg | number : "1.2-2"}}
            </span>
          </div>
          <span *ngIf="item.modifica">
            <input [(ngModel)]="item.kg" placeholder="chilogrammi" type="number" name="kg" class="form-control">
          </span>
        </td>
        <td class="align-middle">
          <div *ngIf="!item.modifica">
            <i-feather name="arrow-up" class="feather-sm"></i-feather>
            <span class="span_text">
              {{ item.h | number : "1.2-2"}}
            </span>
          </div>
          <span *ngIf="item.modifica">
            <input [(ngModel)]="item.h" placeholder="Altezza" type="number" name="h"
              class="form-control">
          </span>
        </td>
        <td class="align-middle">
          <span *ngIf="!item.modifica">
            <i-feather name="arrow-right" class="feather-sm"></i-feather>
            <span class="span_text">
              {{ item.l | number : "1.2-2"}}
            </span>
          </span>
          <span *ngIf="item.modifica">
            <input [(ngModel)]="item.l" placeholder="Larghezza" type="number" name="l" class="form-control">
          </span>
        </td>
        <td class="align-middle">
          <span *ngIf="!item.modifica">
            <i-feather name="arrow-up-right" class="feather-sm"></i-feather>
            <span class="span_text">
              {{ item.p | number : "1.2-2"}}
            </span>
          </span>
          <span *ngIf="item.modifica">
            <input [(ngModel)]="item.p" placeholder="Profondita" type="number" name="p" class="form-control">
          </span>
        </td>
        <td class="align-middle">
          <span *ngIf="!item.modifica">
            <i-feather name="box" class="feather-sm"></i-feather>
            <span class="span_text">
              {{ item.pe | number : "1.2-2"}}
            </span>
          </span>
          <span *ngIf="item.modifica">
            <!-- <input [(ngModel)]="item.p" placeholder="Profondita" type="number" name="p" class="form-control"> -->
          </span>
        </td>
        <td class="align-middle">
          <span *ngIf="!item.modifica">
            <i-feather name="box" class="feather-sm"></i-feather>
            <span class="span_text">
              {{ item.pe333 | number : "1.2-2"}}
            </span>
          </span>
          <span *ngIf="item.modifica">
            <!-- <input [(ngModel)]="item.p" placeholder="Profondita" type="number" name="p" class="form-control"> -->
          </span>
        </td>
        <td class="align-middle">
          <span *ngIf="!item.modifica">
            <i class="fas fa-box"></i>
            <span class=" span_text text-dark font-24 mr-1">
              {{ item.pt | number : "1.2-2" }}
            </span>

          </span>
          <span *ngIf="item.modifica">
            <!-- <input [(ngModel)]="item.p" placeholder="Profondita" type="number" name="p" class="form-control"> -->
          </span>
        </td>
        <td class="align-middle" *ngIf="!isModifyDisabled">
          <a *ngIf="!item.modifica" href="javascript:void(0)" ngbTooltip="Modifica"
            class="link font-16 text-info font-medium mr-2" (click)='edit(item)'>
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="item.modifica" href="javascript:void(0)" ngbTooltip="Salva"
            class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
            <i-feather name="check" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold"
            (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
        </td>
      </tr>
      <tr>
        <td class="align-middle">
          <div class="d-flex align-items-center">
            <i-feather name="box" class="feather-sm"></i-feather>
            &nbsp;
            <span class=" text-dark font-24 mr-1">
              {{ totalekg | number : "1.1-1"}}
            </span>
          </div>
        </td>
        <td class="align-middle">
        </td>
        <td class="align-middle">
        </td>
        <td class="align-middle">
        </td>
        <td class="align-middle">
          <div class="d-flex align-items-center">
            <i-feather name="box" class="feather-sm"></i-feather>
            &nbsp;
            <span class=" text-dark font-24 mr-1">
              {{ totalepv | number : "1.1-1" }}
            </span>
          </div>
        </td>
        <td class="align-middle">
          <div class="d-flex align-items-center">
            <i-feather name="box" class="feather-sm"></i-feather>
            &nbsp;
            <span class=" text-dark font-24 mr-1">
              {{ totalepv333 | number : "1.1-1" }}
            </span>
          </div>
        </td>
        <td class="align-middle">
          <div class="d-flex align-items-center">
             <i class="fas fa-box"></i>
            &nbsp;
            <span class=" text-dark font-24 mr-1">
              {{ totalept | number : "1.1-1" }}
            </span>
          </div>
        </td>
        <td class="align-middle" *ngIf="!isModifyDisabled">
        </td>
      </tr>
    </tbody>
  </table>
</div>
